/**
 * Socket Event to Tool Mapping
 *
 * Maps Socket.IO event names to tool function names
 * for the tool call visibility UI.
 */

// Map socket event names to tool function names
export const SOCKET_EVENT_TO_TOOL: Record<string, string> = {
  'ai_risk_summary': 'find_risk_summary',
  'ai_at_risk_skus': 'find_at_risk_skus',
  'ai_supply_walk': 'get_supply_walk_for_sku',
  'ai_low_point': 'find_low_point',
  'ai_stockout_date': 'find_stockout_date',
  'ai_po_history': 'get_po_history_for_sku',
  'ai_supply_walk_comparison': 'compare_supply_walks',
  'ai_diagnosis': 'diagnose_shortfall',
};

// Events that should create tool calls
export const TOOL_CALL_EVENTS = Object.keys(SOCKET_EVENT_TO_TOOL);
